module.exports = __webpack_public_path__ + "img/banner.cdb63a76.png";